export const ENABLE_NEW_ENTITY_PAGES_ARTICLES_MODULE =
  'enable_new_entity_pages_articles_module';
